import React, { useEffect, useState } from 'react';
import { MapPin, Grid3x3, Tags, Store, Mail, MessageSquare } from 'lucide-react';
import { adminApi } from '../../api';

function StatCard({ icon: Icon, label, value, color }) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 flex items-center gap-4 shadow-sm">
      <div className={`w-12 h-12 rounded-lg flex items-center justify-center text-white ${color}`}><Icon size={22} /></div>
      <div>
        <div className="text-2xl font-bold text-gray-900">{value ?? '—'}</div>
        <div className="text-xs text-gray-500 uppercase tracking-wider">{label}</div>
      </div>
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { adminApi.stats().then(setStats).catch(() => {}); }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-2">Dashboard</h1>
      <p className="text-gray-500 mb-6">Panoramica dei contenuti gestiti dalla piattaforma YUP.</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        <StatCard icon={MapPin} label="Città" value={stats?.cities} color="bg-blue-600" />
        <StatCard icon={Grid3x3} label="Categorie" value={stats?.categories} color="bg-emerald-600" />
        <StatCard icon={Tags} label="Sottocategorie" value={stats?.subcategories} color="bg-purple-600" />
        <StatCard icon={Store} label="Attività" value={stats?.activities} color="bg-orange-600" />
        <StatCard icon={Mail} label="Newsletter" value={stats?.newsletter} color="bg-pink-600" />
        <StatCard icon={MessageSquare} label="Chat" value={stats?.conversations} color="bg-teal-600" />
      </div>
      <div className="mt-8 bg-white rounded-xl border border-gray-200 p-6">
        <h2 className="font-semibold text-gray-900 mb-3">Benvenuto nel CMS YUP</h2>
        <p className="text-sm text-gray-600 leading-relaxed">Da questo pannello puoi gestire tutti i contenuti del sito: città, categorie, sottocategorie, attività (con orari settimanali, telefono, indirizzo, prezzi, sito web), storie, contatti di emergenza e iscrizioni newsletter. Usa il menu laterale per navigare tra le sezioni.</p>
      </div>
    </div>
  );
}
